import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export function ModeToggle() {
  const { mode, toggleMode } = useTheme();
  const isDark = mode === "dark";
  return (
    <button
      data-testid="mode-toggle"
      onClick={toggleMode}
      aria-label={isDark ? "Switch to parchment theme" : "Switch to dark theme"}
      title={isDark ? "Parchment theme" : "Dark theme"}
      className="grid h-8 w-8 place-items-center rounded-md border border-clan-ink/15 bg-clan-ink/[0.04] text-clan-ink backdrop-blur-md transition-colors duration-300 hover:border-clan-accent/60 hover:bg-clan-ink/[0.07] focus:outline-none focus:ring-2 focus:ring-clan-accent sm:h-9 sm:w-9"
    >
      {isDark ? <Moon className="h-4 w-4 text-clan-accent" /> : <Sun className="h-4 w-4 text-clan-accent" />}
    </button>
  );
}
